import {
  faCircleInfo,
  // faCompress,
  // faPlus,
  faXmark,
} from "@fortawesome/pro-regular-svg-icons";

import { IconButton } from "src/design-system/Icon";
import { Tooltip } from "src/design-system/Tooltip";

export const CopilotSidebarHeader: React.FC<{
  onClose: () => void;
}> = ({ onClose }) => (
  <div className="flex h-13 items-center justify-between border-gray-200 border-b">
    <h2 className="font-inter-semibold-13px text-gray-800">Copilot</h2>
    <div className="flex items-center gap-x-2">
      {/* <IconButton
        icon={faPlus}
        size="sm"
        dataLoc="copilot-new-conversation"
      /> */}
      {/* <IconButton
        icon={faCompress}
        size="sm"
        dataLoc="copilot-minimize"
      /> */}
      {/* TODO(TBD): replace placeholder tooltip body and footer copy with final user-facing content. */}
      <Tooltip
        body={
          <ul className="ml-4 list-disc">
            <li>What the user can do with this copilot</li>
            <li>Information user level and dashboard level</li>
            <li>link to documentation</li>
          </ul>
        }
        placement="bottom-end"
        title="Exploration Copilot"
        footerAction={{
          text: "Learn more",
          onClick: () => {
            alert("Open documentation in new tab");
          },
        }}
        asChild
      >
        <IconButton icon={faCircleInfo} size="sm" dataLoc="copilot-info" />
      </Tooltip>
      <IconButton
        dataLoc="copilot-close"
        icon={faXmark}
        size="sm"
        onClick={onClose}
      />
    </div>
  </div>
);
